import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class AtLeastOneBattingOrderWasChosenForEachStackValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const battingOrderOfPrimaryStack = stacking.getBattingOrderByStackNumber(Const.MLB_NON_CONTROLLED_FIRST_GROUP);
        const battingOrderOfSecondaryStack = stacking.getBattingOrderByStackNumber(
            Const.MLB_NON_CONTROLLED_SECOND_GROUP,
        );

        const isCheckedAtLeastOneInPrimaryStack = this.isCheckedAtLeastOneInBattingOrder(battingOrderOfPrimaryStack);
        const isCheckedAtLeastOneInSecondaryStack =
            this.isCheckedAtLeastOneInBattingOrder(battingOrderOfSecondaryStack);

        if (!isCheckedAtLeastOneInPrimaryStack || !isCheckedAtLeastOneInSecondaryStack) {
            this.addError('Should be at least one batting order chosen for each Stack.');
        }
    }

    private isCheckedAtLeastOneInBattingOrder(battingOrder): boolean {
        for (let key in battingOrder) {
            if (battingOrder[key]) {
                return true;
            }
        }
        return false;
    }
}

export default AtLeastOneBattingOrderWasChosenForEachStackValidator;
